import { get, getAll } from '@bigyouth/base'
import axios from 'axios'
import emitter from '../utils/emitter'

const VALID_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line

export default {
  name: 'needs',

  activeStep: 0,
  values: { email: null },

  ui: {
    'steps[]': '[js-needs-step]',
    back: '[js-needs-back]',
    'validates[]': '[js-needs-validate]',
    'types[]': '[js-needs-type]',
    inhabitants: '[js-needs-inhabitants]',
    'fieldsCity[]': '[js-needs-field-city]',
    'fieldsIntercom[]': '[js-needs-field-intercom]',
    'fields[]': '[js-needs-field]',
    'fieldsWrap[]': '[js-needs-field-wrap]',
    'status[]': '[js-needs-status]',
    statusBis: '[js-needs-status-bis]',
    email: '[js-needs-email]',
    'results[]': '[js-needs-results]',
    close: '[js-needs-close]',
    progress: '[js-needs-progress]',
    token: '[js-needs-token]',
  },

  events: [
    {
      on: 'click',
      target: 'validates',
      handle (e) {
        if (!e.target.hasAttribute('js-needs-results')) {
          this.changeStep(parseInt(e.target.dataset.nextStep), false)
        }
      },
    },
    {
      on: 'click',
      target: 'back',
      handle (e) {
        this.changeStep(this.activeStep - 1, true)
      },
    },
    {
      on: 'change',
      target: 'fields',
      handle (e) {
        this.onChangeField(e)
      },
    },
    {
      on: 'change',
      target: 'types',
      handle (e) {
        this.onChangeType(e.target.value)
      },
    },
    {
      on: 'change',
      target: 'status',
      handle (e) {
        // step 3, hide/display step 3B and manage valid / invalid states for validate button
        const validate = get('[js-needs-validate]', e.target.closest('[js-needs-step]'))
        if (e.target.value === 'elected') {
          this.ui.statusBis.classList.remove('hidden')
          this.ui.statusBis.dataset.valid = 0
          validate.classList.add('is-disabled')
        } else {
          this.ui.statusBis.classList.add('hidden')
          this.ui.statusBis.dataset.valid = 1
          validate.classList.remove('is-disabled')
        }
      },
    },
    {
      on: 'keyup',
      target: 'email',
      handle (e) {
        clearTimeout(this.typingTimer)

        if (e.target.value) {
          this.typingTimer = setTimeout(this.validateEmail, 1200)
        }
      },
    },
    {
      on: 'click',
      target: 'results',
      handle (e) {
        this.sendResults(e)
      },
    },
    {
      on: 'click',
      target: 'close',
      handle (e) {
        // wait for modal to be closed
        setTimeout(() => {
          this.resetModule()
        }, 400)
      },
    },
  ],

  sendResults (e) {
    const target = e.target
    const parentStep = e.target.closest('[js-needs-step]')
    const loader = document.createElement('div')
    loader.classList.add('loader')

    const globalError = document.querySelector('.needs-modal__error--end')

    if (globalError) {
      globalError.remove()
    }

    parentStep.append(loader)
    parentStep.classList.add('is-above')

    const formData = new FormData()

    for (const [key, value] of Object.entries(this.values)) {
      formData.append(key, value)
    }

    formData.append('token', this.ui.token.value)

    axios.post('/ajax/needs-module', formData)
      .then(response => {
        loader.remove()
        parentStep.classList.remove('is-above')

        if (response.data.success) {
          window.location = response.data.url
        } else {
          this.createGlobalError(target)
        }
      })
      .catch(e => {
        loader.remove()
        parentStep.classList.remove('is-above')
        this.createGlobalError(target)
      })
  },

  onChangeType (value) {
    // display subtype question on radio select + display/hide corresponding fields in question 1B and 3B
    this.ui.inhabitants.classList.remove('hidden')

    if (value === 'intercom') {
      this.ui.fieldsCity.forEach(input => {
        input.classList.add('hidden')
      })

      this.ui.fieldsIntercom.forEach(input => {
        input.classList.remove('hidden')
      })
    } else {
      this.ui.fieldsCity.forEach(input => {
        input.classList.remove('hidden')
      })

      this.ui.fieldsIntercom.forEach(input => {
        input.classList.add('hidden')
      })
    }

    getAll('[js-needs-field]', this.ui.inhabitants).forEach(input => {
      input.checked = false
    })

    // reset validate button + valid field wrap when a type is choosen
    get('[js-needs-field-wrap]', this.ui.inhabitants).dataset.valid = 0
    get('[js-needs-validate]', this.ui.inhabitants.closest('[js-needs-step]')).classList.add('is-disabled')
  },

  onChangeField (e) {
    const fieldsWrapInStep = getAll('[js-needs-field-wrap]', e.target.closest('[js-needs-step]'))
    const validateButton = get('[js-needs-validate]', e.target.closest('[js-needs-step]'))
    let isComplete = true

    // case check
    if (e.target.checked) {
      if (e.target.dataset.fieldName !== 'expectations') {
        e.target.closest('[js-needs-field-wrap]').dataset.valid = 1
      } else {
        if (e.target.closest('[js-needs-field-wrap]').querySelectorAll('input[type="checkbox"]:checked').length >= 2) {
          e.target.closest('[js-needs-field-wrap]').dataset.valid = 1
        }
      }

      if (e.target.dataset.fieldName) {
        // radio/checkbox cases
        if (e.target.type === 'radio') {
          this.values[e.target.dataset.fieldName] = e.target.value
        } else {
          if (this.values[e.target.dataset.fieldName] === undefined) {
            this.values[e.target.dataset.fieldName] = [e.target.name]
          } else {
            this.values[e.target.dataset.fieldName].push(e.target.name)
          }
        }
      }
    // if uncheck
    } else {
      if (e.target.type === 'radio') {
        e.target.closest('[js-needs-field-wrap]').dataset.valid = 0
      } else {
        const values = this.values[e.target.dataset.fieldName]
        values.splice(values.indexOf(e.target.name), 1)

        const minVal = e.target.dataset.fieldName !== 'expectations' ? 0 : 1

        if (values.length === minVal) {
          e.target.closest('[js-needs-field-wrap]').dataset.valid = 0
        }
      }
    }

    // check all field-wraps to see if validate button can be active
    fieldsWrapInStep.forEach(wrap => {
      if (parseInt(wrap.dataset.valid) === 0) {
        isComplete = false
      }
    })

    if (isComplete) {
      validateButton.classList.remove('is-disabled')
    } else {
      validateButton.classList.add('is-disabled')
    }
  },

  createGlobalError (target) {
    const error = document.createElement('p')
    error.classList.add('needs-modal__error', 'needs-modal__error--end')
    error.innerHTML = 'Erreur lors de la soumission'

    target.parentNode.append(error)
  },

  validateEmail () {
    const isValid = VALID_EMAIL.test(this.ui.email.value)
    const validate = get('[js-needs-validate]', this.ui.email.closest('[js-needs-step]'))
    const errorDisplayed = this.ui.email.parentNode.querySelector('.needs-modal__error')

    if (!isValid) {
      if (errorDisplayed === null) {
        const error = document.createElement('p')
        error.classList.add('needs-modal__error')
        error.innerHTML = "Format d'email incorrect"

        this.ui.email.parentNode.append(error)

        validate.classList.add('is-disabled')
      }

      this.values.email = null
    } else {
      if (errorDisplayed) {
        errorDisplayed.remove()
      }

      this.values.email = this.ui.email.value

      validate.classList.remove('is-disabled')
    }
  },

  changeStep (step, isBack) {
    const oldActiveStep = get('[js-needs-step].is-active')
    const activeStep = get(`[js-needs-step][data-step="${step}"]`)

    activeStep.classList.add('is-active')

    // but additional class to put slide on he left
    if (!isBack) {
      oldActiveStep.classList.add('is-out')
    } else {
      activeStep.classList.remove('is-out')
    }

    oldActiveStep.classList.remove('is-active')

    if (step > 0) {
      this.ui.back.classList.remove('is-hidden')
      this.ui.progress.parentNode.classList.remove('hidden')
    } else {
      this.ui.back.classList.add('is-hidden')
      this.ui.progress.parentNode.classList.add('hidden')
    }

    this.activeStep = step
    this.ui.progress.style.transform = `scaleX(${step / 6})`
  },

  resetModule () {
    this.values = { email: null }
    this.changeStep(0, true)

    this.ui.inhabitants.classList.add('hidden')
    this.ui.statusBis.classList.add('hidden')

    this.ui.fields.forEach(field => {
      field.checked = false
    })

    this.ui.fieldsWrap.forEach(wrap => {
      wrap.dataset.valid = '0'
    })

    this.ui.steps.forEach(step => {
      step.classList.remove('is-out')
    })

    this.ui.validates.forEach(validate => {
      if (validate.dataset.nextStep !== '1') {
        validate.classList.add('is-disabled')
      }
    })

    this.ui.statusBis.dataset.valid = 1
  },

  componentDidMount () {
    emitter.on('openNeedsModal', data => {
      this.changeStep(1)
      this.onChangeType(data.type)

      get(`[js-needs-type][value='${data.type}']`).checked = true
    })
  },
}
